import { ITableByOnFFRR } from "@interfaces/screens/table-by-on-ffrr.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import { IAEAColumnDefinition, IBudgetFormBasicDataMasters } from "@models/*";
import { useSelector } from "react-redux";
import { Dictionary, Utilities, Enums, String, Constants } from "@utils";
import { BatchGridColumnProps } from "@/components/ui/aea-batch-grid/aea-batch-grid";
import { store } from "@/store";
import dxDataGrid from "devextreme/ui/data_grid";
import DataGrid from "devextreme/ui/data_grid";

export class TableByOnFFRRPresenter extends BasePresenter<ITableByOnFFRR> {
    public basicFields: Dictionary<string, IAEAColumnDefinition>;
    public formMasters: IBudgetFormBasicDataMasters;
    public currentTableData: any;
    public summaryConfig: any;
    public currentBudgetData: any;
    public currentLabels: Dictionary<string, string>;

    private monthsToSum: string[];

    constructor(view: ITableByOnFFRR) {
        super(view);
        this.initializePresenter();
        this.initializeVariables();
        this.openCloseModalExcel = this.openCloseModalExcel.bind(this);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    }

    //#region Public Methods
    public get getCurrentData() {
        return this.currentTableData;
    }
    public getAllColumnsDefinitions() {
        this.dispatcher(this.context.budgetStore.getFormBudgetTablesFFCCColumnDefinition())
    }
    public initializeColumns() {
        this.initializeColumnsByColumnsDefinition();
    }
    public renderTableWithData() {
        if (!Utilities.isNullEmptyObject(this.currentTableData)) {
            const currentData = this.currentTableData.map((row: any) => {
                return {
                    Id: row.Id,
                    Ceco: row.PPresCeco ? [row.PPresCeco.id] || [0] : [0],
                    FinanciadorSap: row.OCTAVIAFinanciadorSap ? [row.OCTAVIAFinanciadorSap.id] || [0] : [0],
                    Companias: row.PPresCampanas ? [row.PPresCampanas.id] || [0] : [0],
                    Finalidad: row.PPresFinalidad ? [row.PPresFinalidad.id] || [0] : [0],
                    NaturalezaGastos: row.PPresNatuGasto ? [row.PPresNatuGasto.id] || [0] : [0],
                    // RecuperacionCostes: row.ProaRecupCostes ? [row.ProaRecupCostes.id] || [0] : [0],
                    TotalAnio: row.PPresTotalAnio,
                    Enero: row.PPresEnero,
                    Febrero: row.PPresFebrero,
                    Marzo: row.PPresMarzo,
                    Abril: row.PPresAbril,
                    Mayo: row.PPresMayo,
                    Junio: row.PPresJunio,
                    Julio: row.PPresJulio,
                    Agosto: row.PPresAgosto,
                    Septiembre: row.PPresSeptiembre,
                    Octubre: row.PPresOctubre,
                    Noviembre: row.PPresNoviembre,
                    Diciembre: row.PPresDiciembre,
                };
            });
            this.view.state.setDataSource(currentData);
        }
    }
    public updateCeco() {
        if (!Utilities.isNullObject(this.currentBudgetData.RegionCountry) && this.view.state.columns.length > 0) {
            let fullColumns: any = [...this.view.state.columns];
            let newCecos = this.getBudgetField("Ceco");
            fullColumns[0] = newCecos;
            this.view.state.setColumns(fullColumns);
        }
    }
    public switchView() {
        const readOnly = window.location.hash.indexOf("view?Id") > -1;
        if (readOnly) { this.view.state.setReadOnly(true) }
    }
    public showExcelModal() {
        this.view.state.setModalExcel(!this.view.state.modalExcel);
    }
    public openCloseModalExcel() {
        let openClose = this.view.state.modalExcel ?? false;
        this.view.state.setModalExcel(!openClose);
    }
    public getGridProps() {
        const addRow: any = {};
        const copyExcel: any = {};

        let internalProps: any = {
            id: 'table-by-ffrr',
            pager: {allowedPageSizes : 'all'},
            paging: {enabled: false},
            columnChooser: null,
            filterRow: null,
            headerFilter: null,
            export: { allowExportSelectedData: false },
            groupPanel: null,
            columnMinWidth: 100,
            width: "100%",
            editing: { mode: "cell", allowUpdating: true, allowAdding: false, allowDeleting: true, useIcons: true },
            scrolling: { mode: "standard", rowRenderingMode:"standard"  },
            stateStoring: {
                enabled: true,
                type: "localStorage",
                storageKey: "storage_table-by-ffrr"
            }  
        };

        internalProps.onToolbarPreparing = (e: any) => onToolbarPreparing({ e: e, component: this.getDataFromTable(internalProps.id) });

        let onToolbarPreparing = (e: any) => {
            addRow.location = "after";
            addRow.widget = "dxButton";
            addRow.options = {};
            addRow.options.icon = 'plus';
            addRow.options.onClick = (event: any) => this.addRowGrid(event, e.component);

            copyExcel.location = "after";
            copyExcel.widget = "dxButton";
            copyExcel.options = {};
            copyExcel.options.icon = 'paste';
            copyExcel.options.text = this.currentLabels.get('CopyFromExcel'); //TODO
            copyExcel.options.onClick = (event:any) => { this.showExcelModal() };

            e.e.toolbarOptions.items.unshift(addRow || null, copyExcel || null);
        };
        return { ...internalProps };
    }

    //#endregion

    //#region Private Methods
    private initializePresenter() {
        this.formMasters = useSelector(this.context.budgetStore.selectFormMasters);
        this.basicFields = useSelector(this.context.budgetStore.selectFormBudgetTablesFFCCColumnDefinition);
        this.currentTableData = useSelector(this.context.budgetStore.selectFormTableFFRR);
        this.currentBudgetData = useSelector(this.context.budgetStore.selectCurrentBudget);
    }
    private initializeVariables() {
        this.monthsToSum = Constants.Months.Spanish;
        this.summaryConfig = [
            { column: "TotalAnio", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Enero", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Febrero", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Marzo", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Abril", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Mayo", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Junio", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Julio", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Agosto", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Septiembre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Octubre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Noviembre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Diciembre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT }
        ]
    }
    private initializeColumnsByColumnsDefinition() {
        let columns: BatchGridColumnProps[] = [];
        columns.push(this.getBudgetField("Ceco"));
        columns.push(this.getBudgetField("FinanciadorSap"));
        columns.push(this.getBudgetField("Companias"));
        columns.push(this.getBudgetField("Finalidad"));
        columns.push(this.getBudgetField("NaturalezaGastos"));
        // columns.push(this.getBudgetField("RecuperacionCostes"));
        columns.push(this.getBudgetField("TotalAnio"));
        columns.push(this.getBudgetField("Enero"));
        columns.push(this.getBudgetField("Febrero"));
        columns.push(this.getBudgetField("Marzo"));
        columns.push(this.getBudgetField("Abril"));
        columns.push(this.getBudgetField("Mayo"));
        columns.push(this.getBudgetField("Junio"));
        columns.push(this.getBudgetField("Julio"));
        columns.push(this.getBudgetField("Agosto"));
        columns.push(this.getBudgetField("Septiembre"));
        columns.push(this.getBudgetField("Octubre"));
        columns.push(this.getBudgetField("Noviembre"));
        columns.push(this.getBudgetField("Diciembre"));

        this.view.state.setColumns(columns);
    }
    private getBudgetField(fieldName: string): BatchGridColumnProps {
        if (!Utilities.isNullObject(this.basicFields) && !Utilities.isNullObject(this.formMasters)) {
            let columnDefinition = this.basicFields.get(fieldName);

            let element: BatchGridColumnProps = {
                dataField: columnDefinition.Title,
                title: columnDefinition.NombreColumna,
                fieldType: columnDefinition.TipoCampoProyecta,
                id: columnDefinition.Title
            };
            if (columnDefinition.TipoCampoProyecta === Enums.FieldTypes.Select) {
                element.items = this.getSelectData(columnDefinition.OCTAVIALista);
                element.allItems = this.getSelectAllData(columnDefinition.OCTAVIALista);
            }

            if (["Ceco", "Companias", "Finalidad", "NaturalezaGastos"].includes(fieldName)) {
                element.width = 280;
            }

            if (["TotalAnio"].includes(fieldName)) {
                element.readOnly = true;
                element.calculateCellValue = this.calculateTotalAnio;
            }
            return element;
        }
    }
    private calculateTotalAnio(data: any) {
        const months = Constants.Months.Spanish;
        let value = 0;

        const items = Object.keys(data);
        items.forEach(key => {
            if (months.includes(key)) {
                value += data[key];
            }
        });
        return value;
    }
    
    private getSelectData = (list: string) => {
        if (this.formMasters !== null) {
            switch (list) {
                case Enums.ListTypes.CECO:
                    {
                        let currentBudget = store.getState().budget.currentBudget;
                        if (currentBudget && currentBudget.RegionCountry) {
                            let cecos = this.formMasters.cecos.filter((x: any) => { if (currentBudget != null && currentBudget.RegionCountry[0].id === x.OCTAVIAPaisId && (x.OCTAVIAActivo)) { return true; } })
                            return Utilities.processDropDownData(cecos, Enums.ListTypes.CECO);
                        }
                        return []
                    }
                case Enums.ListTypes.SAPFinancingEntity: return this.convertToSelectItems(this.formMasters.sapFinancingEntities.filter((x: any) => (x.PPresTipoFondoId === 1  && (x.OCTAVIAActivo))), Enums.ListTypes.SAPFinancingEntity, undefined, undefined, undefined, "OCTAVIACodigo");
                case Enums.ListTypes.Campaign: return Utilities.processDropDownData(this.formMasters.campaigns.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.Campaign);
                case Enums.ListTypes.Purpose: {
                    //let interventionLine = this.convertToSelectItems(this.formMasters.interventionLines, Enums.ListTypes.InterventionLine);
                    let purposes = this.convertToSelectItems(this.formMasters.purposes.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.Purpose, undefined, undefined, Constants.Globals.PREFFIX_PURPOSES);
                    return [...purposes];
                }
                case Enums.ListTypes.NatureExpenditure: return Utilities.processDropDownData(this.formMasters.natureExpenditures.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.NatureExpenditure);
                case Enums.ListTypes.ProaCostRecovery: return Utilities.processDropDownData(this.formMasters.costRecovery.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaCostRecovery);
            }
        }
    }
    private getSelectAllData = (list: string) => {
        if (this.formMasters !== null) {
            switch (list) {
                case Enums.ListTypes.CECO:
                    {
                        let currentBudget = store.getState().budget.currentBudget;
                        if (currentBudget && currentBudget.RegionCountry) {
                            let cecos = this.formMasters.cecos.filter((x: any) => { if (currentBudget != null && currentBudget.RegionCountry[0].id === x.OCTAVIAPaisId) { return true; } })
                            return Utilities.processDropDownData(cecos, Enums.ListTypes.CECO);
                        }
                        return []
                    }
                case Enums.ListTypes.SAPFinancingEntity: return this.convertToSelectItems(this.formMasters.sapFinancingEntities.filter((x: any) => x.PPresTipoFondoId === 1), Enums.ListTypes.SAPFinancingEntity, undefined, undefined, undefined, "OCTAVIACodigo");
                case Enums.ListTypes.Campaign: return Utilities.processDropDownData(this.formMasters.campaigns, Enums.ListTypes.Campaign);
                case Enums.ListTypes.Purpose: {
                    //let interventionLine = this.convertToSelectItems(this.formMasters.interventionLines, Enums.ListTypes.InterventionLine);
                    let purposes = this.convertToSelectItems(this.formMasters.purposes, Enums.ListTypes.Purpose, undefined, undefined, Constants.Globals.PREFFIX_PURPOSES);
                    return [...purposes];
                }
                case Enums.ListTypes.NatureExpenditure: return Utilities.processDropDownData(this.formMasters.natureExpenditures, Enums.ListTypes.NatureExpenditure);
                case Enums.ListTypes.ProaCostRecovery: return Utilities.processDropDownData(this.formMasters.costRecovery, Enums.ListTypes.ProaCostRecovery);
            }
        }
    }
    private convertToSelectItems(items: any[], listName: string, keyField: string = "Id", labelField: string = "Title", preffix: string = "", code: string = "") {
        return items.map(item => {
            return {
                id: String.IsNullOrWhiteSpace(preffix) ? item[keyField] : preffix + item[keyField],
                label: item[labelField],
                listName: listName,
                code: String.IsNullOrWhiteSpace(code) ? "" : item[code]
            };
        });
    }

    private addRowGrid = (e: any, dxGrid: dxDataGrid) => {
        if (dxGrid === null) return;

        dxGrid.saveEditData().then(data => {
            if (dxGrid.getDataSource().items().length > 0) {
                dxGrid.closeEditCell();
                dxGrid.addRow();
                const dataSource = dxGrid.getDataSource().items();
                dxGrid.closeEditCell();
                dxGrid.editRow(dataSource.length + 1)
            }
            else {
                dxGrid.addRow();
            }
        });
    }

    private getDataFromTable(tableId: string): DataGrid {
        let element = document.getElementById(tableId);
        if (Utilities.isNullEmptyObject(element)) {
            return null;
        }

        return DataGrid.getInstance(element) as DataGrid;

    }
    //#endregion
}